import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
// -
import {MiniQ2ValuesModel, MiniQ2HasModel} from "./models/MiniQ2Models";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import RowTRComponent from "../../../components/RowTRComponent";
import {QT2GValuesModel} from "./models/QT2GModels";

const MiniQ2Form = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MiniQ2ValuesModel});
    const [has, setHas] = useState({...MiniQ2HasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...MiniQ2ValuesModel});
            setHas({...MiniQ2HasModel});
        }
    }, [item]);

    const onChangeProtocol = (e) => {
        let values_ = {...values};
        values_.band = e.target.value;
        setValues({...values_});
    }

    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <RowTRComponent
                        fieldName="url_1"
                        _TC={_TC}
                        valueIn={values.url_1}
                        hasIn={has.has_url_1}
                        deactivated={MiniQ2ValuesModel.url_1}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"url_2"}
                        _TC={_TC}
                        valueIn={values.url_2}
                        hasIn={has.has_url_2}
                        deactivated={MiniQ2ValuesModel.url_2}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"url_3"}
                        _TC={_TC}
                        valueIn={values.url_3}
                        hasIn={has.has_url_3}
                        deactivated={MiniQ2ValuesModel.url_3}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"url_4"}
                        _TC={_TC}
                        valueIn={values.url_4}
                        hasIn={has.has_url_4}
                        deactivated={MiniQ2ValuesModel.url_4}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>

                </table>

            </div>
        </div>
    )
}
export default MiniQ2Form